module.exports = __webpack_public_path__ + "img/buildings.c253acd5.svg";